import { render, staticRenderFns } from "./LadyCard.vue?vue&type=template&id=1766395d&scoped=true&"
import script from "./LadyCard.vue?vue&type=script&lang=js&"
export * from "./LadyCard.vue?vue&type=script&lang=js&"
import style0 from "./LadyCard.vue?vue&type=style&index=0&id=1766395d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1766395d",
  null
  
)

export default component.exports